module.exports = __webpack_public_path__ + "d138b526488326b72e4d4d1c15fd9945.svg";